import { render } from "./Entities-SchoolJobsView.vue?vue&type=template&id=1f52e9ec"
import script from "./Entities-SchoolJobsView.vue?vue&type=script&lang=js"
export * from "./Entities-SchoolJobsView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__